import { HelpCalloutStatusChangesScreen } from '@/screens/HelpCalloutStatusChangesScreen'

export function HelpCalloutStatusChangesScreenContainer() {
  return <HelpCalloutStatusChangesScreen />
}

